<template>
  <div>
    <!-- <stat-card v-model="total_active_users" class="my-2" :loading="loading">
      {{ $t('total unique user') }}
    </stat-card> -->

    <div>
      <v-card>
        <v-card-text style="min-height: 350px; position: relative">
          <dashboard-graph-loading v-if="loading"></dashboard-graph-loading>
          <template v-if="reportuserbydateOptions && !loading">
            <apexchart
              ref="reportuserbydate"
              type="area"
              height="350"
              :options="reportuserbydateOptions"
              :series="reportuserbydateSeries"
            ></apexchart>
          </template>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
// import StatCard from './../StatCard'
import DashboardGraphLoading from './../DashboardGraphLoading'
import { mapGetters } from 'vuex'
import moment from 'moment'
import VueApexCharts from 'vue-apexcharts'
import analyticApi from '@/api/analytic'
import { handleResponse } from '@/api/util'
export default {
  components: {
    // StatCard,
    DashboardGraphLoading,
    apexchart: VueApexCharts
  },
  props: ['type', 'app', 'date', 'fbpost'],
  data() {
    return {
      loading: true,
      total_active_users: 0,

      reportuserbydateSeries: null,
      reportuserbydateOptions: {
        chart: {
          height: 350,
          type: 'area'
        },
        stroke: {
          curve: 'smooth'
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '55%'
          }
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          type: 'datetime'
        },
        yaxis: {
          title: {
            text: this.$t('active users')
          },
          tickAmount: 1
        },
        tooltip: {
          x: {
            format: 'dd/MM/yy HH:mm'
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
    })
  },
  watch: {
    async app(newVal, oldVal) {
      if (newVal != oldVal) {
        await this.loadData()
      }
    },
    async date(newVal, oldVal) {
      if (newVal != oldVal) {
        await this.loadData()
      }
    }
  },
  async mounted() {
    await this.loadData()
  },
  methods: {
    async loadData() {
      this.loading = true
      var response = await this.fetchData()
      await this.$nextTick()

      // this.total_active_users = response.total_active_users
      var data = response.data.map((el) => {
        return [moment(el.date).format('YYYY-MM-DDT00:00:00'), parseInt(el.activeusers)]
      })

      this.reportuserbydateSeries = [{ name: this.$t('active users'), data: data }]

      var max = 0
      if (data && data.length > 0) {
        max = data.reduce((acc, val) => {
          acc = acc === undefined || val[1] > acc ? val[1] : acc
          return acc
        })
      }
      if (this.$refs.reportuserbydate) {
        this.$refs.reportuserbydate.updateOptions({
          yaxis: {
            max: max + 5
          }
        })
      }
      this.$emit('onLoaded', { loading: false, data: this.reportuserbydateSeries })
      this.loading = false
    },
    async fetchData() {
      let config = {
        params: {
          pageid: this.selectedBot.pageid,
          app: this.app,
          from_date: moment(this.date.start).format('YYYY-MM-DD'),
          to_date: moment(this.date.end).format('YYYY-MM-DD')
        }
      }
      if (this.type == 'inbox') {
        config.params.page_intent = 'inbox'
        const response = await analyticApi.getReportActiveUsersByDate({ config })
        await handleResponse(response)
        if (response.data.responsecode == 200) {
          this.$emit('input', response.data.data)
          return response.data
        } else {
          throw new Error(response.data.responsecode + ': Something went wrong')
        }
      } else {
        if (this.fbpost) {
          config.params.post_id = this.fbpost.id
        }
        config.params.page_intent = 'comment'
        const response = await analyticApi.getReportActiveUsersByDate({ config })
        await handleResponse(response)
        if (response.data.responsecode == 200) {
          this.$emit('input', response.data.data)
          return response.data
        } else {
          throw new Error(response.data.responsecode + ': Something went wrong')
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/report/ReportUserByDate.vue